import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axios';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Switch } from '../../components/ui/switch';
import { Card, CardContent } from '../../components/ui/card';

export default function SupplierForm() {
  const navigate  = useNavigate();
  const { id }    = useParams();
  const editingId = id ? parseInt(id, 10) : null;
  const companyId = +localStorage.getItem('companyId');
  const branchId  = +localStorage.getItem('branchId');

  const [form, setForm] = useState({
    name:     '',
    taxNumber:'',
    mobile:   '',
    address:  '',
    country:  '',
    city:     '',
    phone:    '',
    email:    '',
    notes:    '',
    isActive: true
  });

  // جلب عند التعديل
  useEffect(() => {
    if (!editingId) return;
    axios.get(`/Supplier/${editingId}`)
      .then(res => {
        const d = res.data;
        setForm({
          name:     d.name       || '',
          taxNumber:d.taxNumber || '',
          mobile:   d.mobile    || '',
          address:  d.address   || '',
          country:  d.country   || '',
          city:     d.city      || '',
          phone:    d.phone     || '',
          email:    d.email     || '',
          notes:    d.notes     || '',
          isActive: d.isActive
        });
      })
      .catch(() => alert('❌ فشل في تحميل بيانات المورد'));
  }, [editingId]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = { ...form, companyId, branchId };

    try {
      if (editingId) {
        await axios.put(`/Supplier/${editingId}`, payload);
        alert('✅ تم تحديث المورد');
      } else {
        await axios.post('/Supplier', payload);
        alert('✅ تم إضافة مورد جديد');
      }
      navigate('/suppliers');
    } catch (err) {
      const data = err.response?.data;
      if (data?.errors) {
        alert(Object.entries(data.errors)
          .map(([f, arr]) => `${f}: ${arr.join(', ')}`)
          .join('\n'));
      } else {
        alert(data?.title || '❌ حدث خطأ');
      }
    }
  };

  return (
    <Card className="max-w-md mx-auto mt-10 p-6" dir="rtl">
      <CardContent>
        <h2 className="text-xl font-bold mb-4">
          {editingId ? 'تعديل مورد' : 'إضافة مورد'}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input name="name" placeholder="الاسم"
            value={form.name} onChange={handleChange} required />

          <Input name="taxNumber" placeholder="الرقم الضريبي"
            value={form.taxNumber} onChange={handleChange} />

          <Input name="mobile" placeholder="الجوال"
            value={form.mobile} onChange={handleChange} />

          <Input name="address" placeholder="العنوان"
            value={form.address} onChange={handleChange} />

          <Input name="country" placeholder="الدولة"
            value={form.country} onChange={handleChange} />

          <Input name="city" placeholder="المدينة"
            value={form.city} onChange={handleChange} />

          <Input name="phone" placeholder="الهاتف"
            value={form.phone} onChange={handleChange} />

          <Input name="email" placeholder="البريد الإلكتروني"
            value={form.email} onChange={handleChange} />

          <Input name="notes" placeholder="ملاحظات"
            value={form.notes} onChange={handleChange} />

          <div className="flex items-center gap-2">
            <Switch
              id="isActive-switch"
              name="isActive"
              checked={form.isActive}
              onChange={handleChange}
            />
            <label htmlFor="isActive-switch" className="cursor-pointer font-medium">
              نشط
            </label>
          </div>

          <div className="flex gap-2 mt-4">
            <Button type="submit">💾 حفظ</Button>
            <Button variant="outline" onClick={() => navigate('/suppliers')}>
              ↩️ رجوع
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
